import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import type {
  UsdaFoodDetailResponse,
  UsdaFoodSearchRequest,
  UsdaFoodSearchResponse,
} from '../interfaces/usda.dto';
import { USDA_SERVICE_FE_CONFIG } from './usda-service-fe.config';

const DEFAULT_USDA_ENDPOINT = 'https://api.nal.usda.gov/fdc/v1';

@Injectable({
  providedIn: 'root',
})
export class UsdaServiceFe {
  private readonly httpBackend = inject(HttpBackend);
  private readonly http = new HttpClient(this.httpBackend);
  private readonly config = inject(USDA_SERVICE_FE_CONFIG, {
    optional: true,
  });

  searchFoods(
    request: UsdaFoodSearchRequest,
  ): Observable<UsdaFoodSearchResponse> {
    const body: Record<string, unknown> = {
      query: request.query,
      pageNumber: request.pageNumber ?? 1,
      pageSize: request.pageSize ?? 25,
    };

    if (request.dataType && request.dataType.length > 0) {
      body['dataType'] = request.dataType;
    }
    if (request.sortBy) {
      body['sortBy'] = request.sortBy;
    }
    if (request.sortOrder) {
      body['sortOrder'] = request.sortOrder;
    }

    return this.http.post<UsdaFoodSearchResponse>(
      `${this.getEndpoint()}/foods/search`,
      body,
      { params: this.getApiKeyParams() },
    );
  }

  getFoodById(fdcId: string | number): Observable<UsdaFoodDetailResponse> {
    return this.http.get<UsdaFoodDetailResponse>(
      `${this.getEndpoint()}/food/${fdcId}`,
      { params: this.getApiKeyParams() },
    );
  }

  private getEndpoint(): string {
    return this.config?.endpoint ?? DEFAULT_USDA_ENDPOINT;
  }

  private getApiKeyParams(): HttpParams {
    const apiKey = this.getApiKey();
    if (!apiKey) {
      return new HttpParams();
    }
    return new HttpParams().set('api_key', apiKey);
  }

  private getApiKey(): string | undefined {
    return this.config?.apiKey?.trim() || undefined;
  }
}
